// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"05d3a969","453":"a46e5287","844":"d2fe1d90","959":"5ea2abbd"}[chunkId] + ".chunk.js";
};